

import { Col, Row } from "react-bootstrap";


export default function AdminPage3 () {
    return (
        <div className="overflow-auto" style={{width:'100%'}}>
            <div className="container flex-grow">
                <Row>
                    <Col>
                        <h3>YES</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <img src="https://picsum.photos/800"></img>
                    </Col>
                </Row>
            </div>
        </div>
    )
}